<template lang="pug">
.not-found
	h1 Not Found
	router-link.button(to='/app') Return to App
</template>

<script>
export default {

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.not-found {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;

	h1 {
		color: $color-secondary;
	}

	.button {
		margin-top: 60px;
	}
}
</style>
